import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { FornecedorBanco } from "../../../../domain/models/fornecedor_banco";
import { zodResolver } from "@hookform/resolvers/zod";
import { FornecedorBancoForm, FornecedorBancoSchema } from "../../../schemas/Fornecedor_cadastro/fornecedor_banco";
import { useEffect } from "react";

/**
 * FornecedorBancoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedBanco: FornecedorBanco | null;
  onClose: () => void;
  onSubmit: (form: FornecedorBancoForm) => void;
};

export const FornecedorBancoModal = ({
  open,
  saving,
  loading,
  selectedBanco,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<FornecedorBancoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(FornecedorBancoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedBanco) {
        hookForm.setValue('tipoConta', selectedBanco.tipoConta ?? 0);
        hookForm.setValue('banco', selectedBanco.nomeBanco ?? '');
        hookForm.setValue('agencia', selectedBanco.agencia ?? '');
        hookForm.setValue('conta', selectedBanco.nrConta ?? '');
        hookForm.setValue('contaDigito', selectedBanco.digito ?? '');
        hookForm.setValue('operacao', selectedBanco.operacao ?? '');
        hookForm.setValue('favorecido', selectedBanco.favorecido ?? '');
        hookForm.setValue('cpfCnpj', selectedBanco.cpfCnpj ?? '');
        hookForm.setValue('pix', selectedBanco.pix ?? '');
      } else {
        hookForm.reset({ tipoConta: 0 });
      }
    }
  }, [
    open,
    selectedBanco,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Banco"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4">
        <FormRadioGroupInput
          name='tipoConta'
          label='Tipo de Conta?'
          options={[
            { id: 0, label: 'Corrente' },
            { id: 1, label: 'Poupança' },
          ]}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='banco'
          label='Banco'
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='agencia'
          label='Agência'
          reactHookForm={hookForm}
        />

        <div className="flex flex-row gap-2 items-center">
          <DefaultFormInput
            name='conta'
            label='Conta'
            reactHookForm={hookForm}
          />

          <p className="text-black dark:text-white">-</p>

          <div className="w-[7rem]">
            <DefaultFormInput
              name='contaDigito'
              label=''
              reactHookForm={hookForm}
            />
          </div>
        </div>

        <DefaultFormInput
          name={'operacao'}
          label={"Operação"}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name={'favorecido'}
          label={"Favorecido"}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name={'cpfCnpj'}
          label={"CPF / CNPJ"}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name={'pix'}
          label={"Pix"}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}